import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { value: null }
const _hoisted_2 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("select", {
      class: "form-select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedValue) = $event))
    }, [
      _createElementVNode("option", _hoisted_1, _toDisplayString(_ctx.emptyLabel), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estateTypes, (estateType) => {
        return (_openBlock(), _createElementBlock("option", { value: estateType }, _toDisplayString(_ctx.capitalizeFirstLetter(_ctx.$t('estateType.' + estateType + '.singular.first_case'))), 9, _hoisted_2))
      }), 256))
    ], 512), [
      [_vModelSelect, _ctx.selectedValue]
    ])
  ]))
}